import React from 'react';

import { Maybe } from 'src/common/types/Maybe';

export type AdditionalCommentsDetails = {
  anythingElse: Maybe<string>;
};

type AdditionalCommentsProps = {
  bridgeSubmissionDetails: AdditionalCommentsDetails;
};

export const AdditionalComments = ({ bridgeSubmissionDetails }: AdditionalCommentsProps) => {
  if (!bridgeSubmissionDetails.anythingElse || bridgeSubmissionDetails.anythingElse.length <= 0) {
    return null;
  }

  return (
    <li>
      <span className="label">Add&apos;l:</span> {bridgeSubmissionDetails.anythingElse}
    </li>
  );
};
